import React, { useEffect, useState, useRef } from "react";
import { Layout, Row, message, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FetchLandingPageAction } from "../../redux/action/LandingPageAction";
import { FetchAllNotificationAction, FetchSaveNotificationAction, FetchDeleteNotificationAction, FetchPublishNotificationAction } from "../../redux/action/NotificationCenterAction";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { useAuth } from "../../utils/auth/useAuth";
import { LoadingSpinner, CardV2, Button, DataTable, Tag, ButtonIcon, Modal, TextArea, TextInput, Icon, EmptyStateV2, Sidepanel, FileUploadV2, Radio, Notification } from "pepsico-ds";
import "../../components/Layout/Layout.scss";
import CommodityPageHeader from "../../components/Header/CommodityPageHeader";
import { call7DaysNpsLogic } from "../../utils/utils";
import Notif_banner from '../../assets/Notif_banner.svg'
import NoData from "../../components/NoData/NoData";
import Vector from '../../assets/Vector.svg'
import { useToast } from '../../components/Toast/ToastContext';
import NotificationPrompt from "./NotificationPrompt";
import SingleSelectDropdown from "../../components/Dropdown/SingleSelectDropdown";
import MultiSelectDropdown from "../../components/Dropdown/MultiSelectDropdown";
import { useTour } from '../../routes/JoyrideProvide'
import { useLoginEffects } from "../WalkmeTour/UseLoginEffects";

const { Content } = Layout;

const renderActionButton = (icon, onClickAction, data, action) => (
    <ButtonIcon
        className=""
        color="Interaction/Active"
        icon={icon}
        label={action} // Or specific labels like icon === 'send' ? 'Publish' : 'Edit'
        onClick={() => onClickAction(data, action)}
        size="medium"
        style={{}}
        type="default"
    />
);


/* istanbul ignore next */
function formatFileSize(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/* istanbul ignore next */
export function PHFileUploadItem({ file, showDelete = false, setBulkUploadFile={}, setExcelFiles= {}, setExcelFilesForDisplay= {}, setExcelFileSize={} }) {
    return (
      <div className={"ph-file-item-container"}>
        <div style={{display: "flex"}}>
            <Icon
                alt="alt value"
                className="$color-icon-default"
                icon="insert_drive_file"
                size="medium"
                style={{alignItems:"center"}}
            />
            <div style={{ marginLeft:"8px" }}>
                <div className="file-name">{file.fileName}</div>
                { file.fileSize !="0" && file.fileSize!=null && file.fileSize!="null" && <div className="file-size">{file.fileSize}</div> }
            </div>
        </div>
        <div style={{display: "flex"}}>
            <ButtonIcon
                className=""
                color="Interaction/Active"
                icon="download"
                label=""
                onClick={function clickButton() {
                    window.open(file?.fileUrl, "_blank", "noopener")
                }}
                size="medium"
                style={{ marginRight:"8px" }}
                type="naked"
            />
            {
            showDelete && <ButtonIcon
                className=""
                color="Interaction/Active"
                icon="delete"
                label=""
                onClick={function clickButton() {
                    setExcelFiles([])
                    setExcelFilesForDisplay([])
                    setExcelFileSize(null);
                    setBulkUploadFile(null);
                }}
                size="medium"
                style={{}}
                type="naked"
            />
            }

        </div>
      </div>
    );
};


/* istanbul ignore next */
const ExcelFileUploader = ({
  excelFiles,
  excelFilesForDisplay,
  setExcelFiles,
  setExcelFileSize,
  setUploadHelperText,
  setExcelFilesForDisplay = {},
  setExcelFileBase64 = {},
  setIsExcelFileProcessing = {},
  updateExcelUploadDisplay,
  convertToBase64,
  uploadHelperText,
    onBlockedDrop = () => {}
}) => {
        const [uploaderInstanceKey, setUploaderInstanceKey] = useState(0);
        const blockedDropInFlightRef = useRef(false);
        const unblockDropTimerRef = useRef(null);
        const uploaderHostRef = useRef(null);

        const removeDuplicateUploaderNodes = () => {
            const host = uploaderHostRef.current;
            if (!host) return;

            const uploaderNodes = host.querySelectorAll('.notification-center-upload');
            if (uploaderNodes.length <= 1) return;

            uploaderNodes.forEach((node, index) => {
                if (index > 0 && node?.parentNode) {
                    node.parentNode.removeChild(node);
                }
            });
        };

        useEffect(() => {
            return () => {
                if (unblockDropTimerRef.current) {
                    clearTimeout(unblockDropTimerRef.current);
                }
            };
        }, []);

        useEffect(() => {
            const timer = setTimeout(() => {
                removeDuplicateUploaderNodes();
            }, 0);

            return () => clearTimeout(timer);
        }, [uploaderInstanceKey, excelFilesForDisplay.length, uploadHelperText]);

  return (
    <div
            ref={uploaderHostRef}
            onDropCapture={(e) => {
                // e.preventDefault();
                // e.stopPropagation();
                
                console.log(e)
                const entry = e?.dataTransfer?.items?.[0]?.webkitGetAsEntry?.();
                const isBlockedDrop = e?.dataTransfer == undefined || entry?.isDirectory;
                if (isBlockedDrop) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (blockedDropInFlightRef.current) {
                        return;
                    }
                    blockedDropInFlightRef.current = true;
                    setUploadHelperText("Folder upload is not supported.");
                    onBlockedDrop();
                    setUploaderInstanceKey((prev) => prev + 1);
                    unblockDropTimerRef.current = setTimeout(() => {
                        blockedDropInFlightRef.current = false;
                        unblockDropTimerRef.current = null;
                    }, 180);
                }

                // Reset FileUploadV2 internal drag state so the UI never gets stuck after blocked drops.
                // setUploaderInstanceKey((prev) => prev + 1);
            }}
    >
    <FileUploadV2
        key={uploaderInstanceKey}
        accept=".xlsx"
        buttonLabel="Upload file"
        className="notification-center-upload"
        description="Drag and drop your file here (only .xlsx)"
        feedbackType="info"
        files={excelFilesForDisplay}
        disabled={excelFilesForDisplay.length > 0}
        helperText={
          uploadHelperText ? (
            <div style={{ color: "#aa001a" }}>{uploadHelperText}</div>
          ) : (
            excelFilesForDisplay.length > 0 && (
              <div style={{ fontSize: "12px", fontWeight: 700, color: "#2D2D2D" }}>
                Uploaded File
              </div>
            )
          )
        }
        isShowUploadedFileCount={false}
        label="Upload file"
        maxFiles={1}
        maxListHeight="287px"
        onDelete={() => {
          setUploadHelperText("");
          setExcelFileSize(null);
          setExcelFiles([]);
          setExcelFilesForDisplay([]);
          setExcelFileBase64("");
          setIsExcelFileProcessing(false);
        }}
        onFileError={(value) => {
          setUploadHelperText(value);
          setIsExcelFileProcessing(false);
        }}
        onFilePause={(value) => console.log(value)}
        onFileResume={(value) => console.log(value)}
        onUpdate={() => {}}
        onValidateFile={(file) => {
                

          if (file.size > 10 * 1024 * 1024) {
            setUploadHelperText("File size exceeds the 10 MB limit. Please upload a smaller file");
            return false;
          }
          setUploadHelperText("");

          const fileSize = formatFileSize(file.size);
          setExcelFiles([file]);
          setExcelFileSize(fileSize);
          setExcelFileBase64("");
          setIsExcelFileProcessing(true);

        // Show bar immediately at 5% so user sees it start
          updateExcelUploadDisplay(file, 5, "uploading");

        // Simulate progress ticks while FileReader works
        // (FileReader is too fast for onprogress to fire on small files)
          let simulated = 5;
          const interval = setInterval(() => {
            simulated = Math.min(simulated + 12, 85);
            updateExcelUploadDisplay(file, simulated, "uploading");
          }, 150);

          convertToBase64(file)
            .then((base64) => {
              clearInterval(interval);
            // Drive to 100% so user sees completion, then mark as done
              updateExcelUploadDisplay(file, 100, "uploading");
              setTimeout(() => {
                setExcelFileBase64(base64);
                updateExcelUploadDisplay(file, 100, "completed");
                setIsExcelFileProcessing(false);
              }, 400);
            })
            .catch(() => {
              clearInterval(interval);
              setUploadHelperText("Unable to process selected file");
              setExcelFiles([]);
              setExcelFilesForDisplay([]);
              setExcelFileSize(null);
              setExcelFileBase64("");
              setIsExcelFileProcessing(false);
            });

          return true;
        }}
        type="default"
        uploadIcon="cloud_upload"
        uploadedFilesLabel="Uploaded Files"
        variant="complete"
            />
    </div>
  );
};
  


function NotificationCenter() {

	const dispatch = useDispatch();
	const { authState } = useAuth();
	const [userInfo, setUserInfo] = useState({});
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [isUserDataFetched, setIsUserDataFetched] = useState(false)

	const [showNewNotificationModal, setshowNewNotificationModal] = useState(false);
    const [ignoreNextSidePanelClose, setIgnoreNextSidePanelClose] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showPublishModal, setShowPublishModal] = useState(false);
	const [currentData, setCurrentData] = useState({});
    const messageRef = useRef(null);
    const [messageHeaderInput, setMessageHeaderInput] = useState("");
    const [messageInput, setMessageInput] = useState("");
    const [bulkUploadFile, setBulkUploadFile] = useState({});
    const [messageInputCount, setMessageInputCount] = useState(0);
    const [viewOnly, setViewOnly] = useState(true);
    const [modalHeader, setModalHeader] = useState("")
    const { showToast } = useToast();
    const [allNotifications, setAllNotifications] = useState([])

    const [allCategoriesMap, setAllCategoriesMap] = useState([])
    const [allCategoriesL0, setAllCategoriesL0] = useState([])
    const [allCategoriesL1, setAllCategoriesL1] = useState([])
    const [categoriesL0Selected, setCategoriesL0Selected] = useState([])
    const [categoriesL1Selected, setCategoriesL1Selected] = useState([])

    const [allEmailList, setAllEmailList] = useState([])
    const [selectedEmailList, setSelectedEmailList] = useState([])
    const [finalUserEmailList, setUserFinalEmailList] = useState([]);

    const [selectedAllRadioIndex, setSelectedAllRadioIndex] = useState(0)
    const [selectedCategoryRadioIndex, setSelectedCategoryRadioIndex] = useState(null)
    const [selectedEmailRadioIndex, setSelectedEmailRadioIndex] = useState(null)
    const [selectedBulkRadioIndex, setSelectedBulkRadioIndex] = useState(null)
    const { startTour } = useTour();


    const [uploadHelperText, setUploadHelperText] = useState("");
    const [excelFiles, setExcelFiles] = useState([]);
    const [excelFilesForDisplay, setExcelFilesForDisplay] = useState([]);
    const [excelFileSize, setExcelFileSize] = useState("");
    const [excelFileBase64, setExcelFileBase64] = useState("");
    const [isExcelFileProcessing, setIsExcelFileProcessing] = useState(false);
    
const updateExcelUploadDisplay = (file, progress, status) => {
  if (!file) return;

  setExcelFilesForDisplay([
    {
      name: file.name,
      size: formatFileSize(file.size),
      progress,
      status,
    },
  ]);
};



    const manageNotification = (notificationData, action) => {
        if(action === "Delete") {
            setCurrentData(notificationData);
            setShowDeleteModal(true);
        }
        if(action === "Publish") {
            setCurrentData(notificationData);
            setShowPublishModal(true);
        }
        if(action === "View" || action === "Edit") {
            setCurrentData(notificationData);
            setshowNewNotificationModal(true);
            setMessageHeaderInput(notificationData.title);
            setMessageInput(notificationData.message);
            
            setSelectedEmailRadioIndex(null);
            setSelectedCategoryRadioIndex(null);
            setSelectedAllRadioIndex(null);
            setSelectedBulkRadioIndex(null);
            const requestType = notificationData.requestCategory
            if (requestType === "SPECIFIC_USER") {
                setSelectedEmailRadioIndex(0);
            } else if (requestType === "SPECIFIC_CATEGORY") {
                setSelectedCategoryRadioIndex(0);
            } else if (requestType === "BULK_UPLOAD") { // Need to update Correct Text
                setSelectedBulkRadioIndex(0);
            } else  {
                setSelectedAllRadioIndex(0);
            }

            setCategoriesL0Selected(allCategoriesL0?.filter(item => item.displayText === notificationData.l0));
            const l1Values = getL1Values(allCategoriesMap, notificationData.l0)?.map((item, index) => ({ displayText: item, id: index + 1 }));
            setAllCategoriesL1(l1Values);
            setCategoriesL1Selected(l1Values?.filter(item=>notificationData?.l1.includes(item.displayText)));

            setSelectedEmailList([]);
            setUserFinalEmailList(notificationData.email);
            setBulkUploadFile({
                fileName: notificationData.fileName,
                fileSize: (notificationData.fileSize),
                fileUrl: notificationData.fileUrl
            })


            if(action === "View") {
                setModalHeader("Notification")
                setViewOnly(true);
            } else {
                setModalHeader("Notification Draft")
                setViewOnly(false);
            }
        }
    }

    const publishNotification = (notificationData) => {
        let requestObject = {
            id: notificationData?.id,
            emailId:userInfo?.email,
        }
		setIsDataLoading(true)
         
        let message = "Notification has been published successfully.";
        if(notificationData?.requestCategory==="BULK_UPLOAD") {
            message = "Notification request has been submitted successfully."
        }
        showToast('success', message, {
            icon: <Icon alt="" icon="check_circle" size="medium" />
        });
        dispatch(FetchPublishNotificationAction(requestObject));
    }
    const deleteNotification = (notificationData) => {
        let requestObject = {
            emailId:userInfo?.email,
            id: notificationData?.id,
        }
		setIsDataLoading(true)
        showToast('info', "Notification draft has been deleted", {
            icon: <Icon alt="" icon="info" size="medium" />
        });
        dispatch(FetchDeleteNotificationAction(requestObject));
    }

    /* istanbul ignore next */
    const handleNewNotification = async (buttonAction) => {
        let requestType = "";
        let base64= "";
        let fileName = "";
        if (selectedAllRadioIndex === 0) {
            requestType= "ALL";
        } else if (selectedCategoryRadioIndex === 0) {
            requestType= "SPECIFIC_CATEGORY";
        } else if (selectedEmailRadioIndex === 0) {
            requestType= "SPECIFIC_USER";
        } else if (selectedBulkRadioIndex === 0) {
            requestType= "BULK_UPLOAD";
            fileName = excelFiles?.[0]?.name;
            base64 = excelFileBase64; 
        }
        let requestObject = {
            id: -1,
            subject: messageHeaderInput,
            body: messageInput,
            emailId:userInfo?.email,
            status: buttonAction,
            requestCategory: requestType,
            email: finalUserEmailList,
            l0: categoriesL0Selected?.[0]?.displayText || "",
            l1: categoriesL1Selected?.map(item => item.displayText) || [],
            file: base64,
            fileName: fileName,
            fileSize: excelFileSize,
            fileUrl: bulkUploadFile?.fileUrl || "",
        }
        if(modalHeader==="Notification Draft") {
            requestObject = {
                ...requestObject,
                id: currentData.id
            }
        } 
        let message = "Notification has been published successfully.";
        if(requestType==="BULK_UPLOAD") {
            message = "Notification request has been submitted successfully"
        }
        if(buttonAction==="Published") {
            showToast('success', message, {
                icon: <Icon alt="" icon="check_circle" size="medium" />
            });
        }
		setIsDataLoading(true)
        resetSidePanel();
        dispatch(FetchSaveNotificationAction(requestObject));

    }
    
    /* istanbul ignore next */
   const cellDataFunction = (ctx) => {
    const colId = ctx.column.id
    const columnHeader = ctx.column.columnDef.header;
    const value = ctx.row.original[colId];
    const publishStatus = ctx.row.original["status"]
    const notificationData = ctx.row.original;
        if(value==null) {
            return <div>-</div>
        }
        if(colId==="status") {
            return <Tag
                color={value=="Published"?"green":value=="Pending"?"orange":"gray"}
                size="large"
                style={{}}
                isCopyable={false}
                text={value}
                type="default"
                className="notification-status-tag"
            />

        }
    if (columnHeader === "  ") {
        if (publishStatus === "Published" || publishStatus === "Pending") {
            return (
                <div style={{ display: 'flex', gap: '12px', width: '145px', justifyContent: 'flex-end', paddingRight: '12px' }}>
                    {renderActionButton("remove_red_eye", manageNotification, notificationData, "View")}
                </div>
            )
        }
        
        if (publishStatus === "Draft") {
            return (
                <div style={{ display: 'flex', gap: '12px', width: '145px' }}>
                    {renderActionButton("send", manageNotification, notificationData, "Publish")}
                    {renderActionButton("edit", manageNotification, notificationData, "Edit")}
                    {renderActionButton("delete", manageNotification, notificationData, "Delete")}
                </div>
            );
        }
    }
    if(colId === "title") {
        return (
            <div>
                {value.length > 30 ? (
                    <span title={value}>{value.slice(0, 30)}...</span>
                ) : (
                    value
                )}
            </div>
        );
    }
    if(colId === "message") {
            // const printedValue = getHtmlTextLengthRegex(value,true);
        const printedValue = getHtmlTextLengthWithSpaces(value,true).replaceAll("&nbsp;", ' ');
            // return (
            // <div dangerouslySetInnerHTML={{ __html: value }} className="html-inline-wrapper"/>
            // )
        return (
            <div>
                {printedValue.length > 40 ? (
                    <span title={printedValue}>{printedValue.slice(0, 40)}...</span>
                ) : (
                    printedValue
                )}
            </div>
        );

    }
    return <div>{value}</div>;

}

    
    const tableColumns = [
        { columnKey: 'a', header: '' },
        { columnKey: 'id', header: "ID", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
        { columnKey: 'title', header: "Title", columnAlignment:'left', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
        { columnKey: 'message', header: "Message", columnAlignment:'left', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
        { columnKey: 'createdOn', header: "Creation Time", columnAlignment:'left', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
        { columnKey: 'status', header: "Status", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction },
        { columnKey: 'id', header: "  ", columnAlignment:'center', size: 90, minSize: 90, maxSize: 140, cellData: cellDataFunction, enableSorting: false },
    ]

	
	useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				setUserInfo(user);
				dispatch(FetchLandingPageAction(user));
				setIsUserDataFetched(true)
			}
		}
		setIsDataLoading(true)
		fetchUserInfo();
	}, []);

    useEffect(() => {
        return () => {
            dispatch({ 
                type: 'RESET_ALL_NOTIFICATION_ACTION', 
                payload: "RESET_ALL_NOTIFICATION_ACTION" 
            });
            dispatch({ 
                type: 'RESET_SAVE_NOTIFICATION_ACTION', 
                payload: "RESET_SAVE_NOTIFICATION_ACTION" 
            });
            dispatch({ 
                type: 'RESET_DELETE_NOTIFICATION_ACTION', 
                payload: "RESET_DELETE_NOTIFICATION_ACTION" 
            });
            dispatch({ 
                type: 'RESET_PUBLISH_NOTIFICATION_ACTION', 
                payload: "RESET_PUBLISH_NOTIFICATION_ACTION" 
            });
        };
    }, []);

    /* istanbul ignore next */
    function getHtmlTextLengthRegex(htmlString, flag = false) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const plainText = doc.body.textContent || "";
        if (flag) {
            return plainText;
        }
        return plainText.length;
    }

    /* istanbul ignore next */
    function getHtmlTextLengthWithSpaces(htmlString, flag = false) {
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    
        // Helper to walk the tree and collect text with spaces
        function getTextWithSpaces(node) {
            let texts = [];
            node.childNodes.forEach(child => {
                if (child.nodeType === Node.TEXT_NODE) {
                    texts.push(child.textContent);
                } else {
                    // Recurse and add a space separator for elements
                    texts.push(getTextWithSpaces(child));
                }
            });
            return texts.join(' ');
        }
    
        const rawText = getTextWithSpaces(doc.body);
        // Collapse multiple spaces and trim edges
        const cleanText = rawText.replace(/\s+/g, ' ').trim();
    
        return flag ? cleanText : cleanText.length;
    }

	const userData = useSelector((state) => state.getLandingPageReducer);

    useLoginEffects(userData)
	const allNotificationData = useSelector((state) => state.getAllNotificationReducer);
	const saveNotificationData = useSelector((state) => state.getSaveNotificationReducer);
	const deleteNotificationData = useSelector((state) => state.getDeleteNotificationReducer);
	const publishNotificationData = useSelector((state) => state.getPublishNotificationReducer);

    
    const getL0s = (arr) => arr?.map(item => item.name);
    const getL1Values = (arr, selectedName) => {
        const match = arr.find(item => item.name === selectedName);
        return match ? match.l1 : [];
    };
    /* istanbul ignore next */
    const onL0Selected = (value) => {
        
        if (value && value.length>0) {
            setCategoriesL0Selected(value);
            
            const l1s = getL1Values(allCategoriesMap, value?.[0]?.displayText)?.map((item, index) => ({ displayText: item, id: index + 1 }))
            setCategoriesL1Selected([]);
            setAllCategoriesL1(l1s);
        }
    }
    /* istanbul ignore next */
    const onL1Selected = (value) => {
        if (value && value.length>0) {
            setCategoriesL1Selected(value);
        } else {
            if (value && value.length === 0) {
                setCategoriesL1Selected([])
                message.warning("At least one L1 selection is required")
            }
        }
    }
    const onEmailSelected = (value) => {
        if (value && value.length>0) {
            const email = value[0]?.displayText
            setSelectedEmailList([]);
            setUserFinalEmailList(prev => {
                const emailExists = prev.includes(email);
                return emailExists ? prev : [...prev, email];
            });
        }
    }
	/* istanbul ignore next */
    const removeEmailFromList = (value) => {
        const newEmailList = finalUserEmailList.filter(x => x !== value);
        setUserFinalEmailList(newEmailList)
    }
    /* istanbul ignore next */
    useEffect(() => {
        if (allNotificationData && allNotificationData?.type === "SUCCESS_ALL_NOTIFICATION_ACTION") {
            setIsDataLoading(false)

            let tempNotifications = [];
            if(allNotificationData?.data?.notifications?.length>0) {
                tempNotifications = allNotificationData?.data?.notifications?.map(item => ({
                    id: item.id,
                    title: item.title,
                    message: item.body,
                    createdOn: item.createdAt,
                    status: item.status,
                    requestCategory: item.requestCategory,
                    email: item.email,
                    l0: item.l0,
                    l1: item.l1,
                    fileName: item.fileName,
                    fileSize: item.fileSize || "0",
                    fileUrl: item.blobUrl
                }));
            }
            setAllNotifications(tempNotifications)

            setAllCategoriesMap(allNotificationData?.data?.userCategoryResponse?.category);
            const l0s = getL0s(allNotificationData?.data?.userCategoryResponse?.category)?.map((item, index) => ({ displayText: item, id: index + 1 }));
            setAllCategoriesL0(l0s);
            // setCategoriesL0Selected([l0s?.[0]])
            // const l1s = getL1Values(allNotificationData?.data?.userCategoryResponse?.category, l0s?.[0]?.displayText)?.map((item, index) => ({ displayText: item, id: index + 1 }))
            // setAllCategoriesL1(l1s);
            // setCategoriesL1Selected([]);

            const emailIds = allNotificationData?.data?.userCategoryResponse?.email?.map((item, index) => ({ displayText: item, id: index + 1 }));
            setAllEmailList(emailIds);
            setSelectedEmailList([])


        }
    }, [allNotificationData])

    
    /* istanbul ignore next */
    useEffect(() => {
        if (saveNotificationData && saveNotificationData?.type === "SUCCESS_SAVE_NOTIFICATION_ACTION") {
		    dispatch(FetchAllNotificationAction());
        }
    }, [saveNotificationData])

    
    /* istanbul ignore next */
    useEffect(() => {
        if (deleteNotificationData && deleteNotificationData?.type === "SUCCESS_DELETE_NOTIFICATION_ACTION") {
		    dispatch(FetchAllNotificationAction());
        }
    }, [deleteNotificationData])

    
    /* istanbul ignore next */
    useEffect(() => {
        if (publishNotificationData && publishNotificationData?.type === "SUCCESS_PUBLISH_NOTIFICATION_ACTION") {
		    dispatch(FetchAllNotificationAction());
        }
    }, [publishNotificationData])
	
    /* istanbul ignore next */
    useEffect(() => {
		if (isUserDataFetched && userData && userData?.type === "SUCCESS_LANDING_PAGE_ACTION") {

		call7DaysNpsLogic(dispatch, userData)
		setIsDataLoading(true)
		
		dispatch(FetchAllNotificationAction());
		}
		// 7 days NPS logic
    }, [userData])

    
    /* istanbul ignore next */
    const validateSidePanel = () => {
        // returns true to disable publish button and false to enable publish button
        const inputValidation = messageHeaderInput.trim()==="" || getHtmlTextLengthRegex(messageInput.trim())===0;
        if(inputValidation) {
            return inputValidation;
        }
        
        if (selectedAllRadioIndex === 0) {
            return false;
        } else if (selectedCategoryRadioIndex === 0) {
            if (categoriesL0Selected.length === 0 || categoriesL1Selected.length === 0) {
                return true;
            }
            return false;
        } else if (selectedEmailRadioIndex === 0) {
            if (finalUserEmailList.length === 0) {
                return true;
            }
            return false;
        } else if (selectedBulkRadioIndex === 0) {
             if (isExcelFileProcessing) {
        return true;
    }

    if (excelFiles.length === 0 && !bulkUploadFile?.fileName) {
        return true;
    }

    if (excelFiles.length > 0 && !excelFileBase64) {
        return true;
    }

    return false;
        }
    }

    const resetSidePanel = () => {
    setMessageHeaderInput("");
    setMessageInput("");

    setSelectedAllRadioIndex(0);
    setSelectedCategoryRadioIndex(null);
    setSelectedEmailRadioIndex(null);
    setSelectedBulkRadioIndex(null);

    setCategoriesL0Selected([]);
    setAllCategoriesL1(getL1Values(allCategoriesMap, allCategoriesL0[0]?.displayText)?.map((item, index) => ({ displayText: item, id: index + 1 })));
    setCategoriesL1Selected([]);

    setSelectedEmailList([]);
    setUserFinalEmailList([]);

    setExcelFileSize("");
    setUploadHelperText("");
        setExcelFiles([])
        setExcelFilesForDisplay([])
    setExcelFileBase64("");
        setBulkUploadFile({})
    setIsExcelFileProcessing(false);
}
    /* istanbul ignore next */
    // useEffect(()=>{
	// 	console.log("hideTour: ", localStorage.getItem('hideTour'))
	// 	const hideTour = localStorage.getItem('hideTour') === 'true';
	// 	if (userData?.isWalkMeEnabled && !hideTour) {
	// 	startTour();
	// 	}
		
	// },[userData])
    // /* istanbul ignore next */
	//  useEffect(() => {
	// 	const shouldAnimate = sessionStorage.getItem("showLoginAnimation");

	// 	if (shouldAnimate !== "true") return;

	// 	const observer = new MutationObserver(() => {
	// 		const element = document.querySelector(".rocket-wrapper");

	// 		if (element) {
	// 		element.classList.add("animate-blue");

	// 		element.addEventListener(
	// 			"animationend",
	// 			() => {
	// 			element.classList.remove("animate-blue");
	// 			},
	// 			{ once: true }
	// 		);
	// 		sessionStorage.removeItem("showLoginAnimation");
	// 		observer.disconnect(); // stop observing
	// 		}
	// 	});

	// 	observer.observe(document.body, {
	// 		childList: true,
	// 		subtree: true,
	// 	});

	// 	return () => observer.disconnect();
	// }, []);

    const convertToBase64 = (file, onProgress) => {
    if (!file || !(file instanceof Blob)) {
        console.warn("Invalid file provided to convertToBase64");
        return Promise.resolve("");
    }

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
    });
};

	if(authState?.isAuthenticated){
		return(
			<>

									<div style={{}}>
										<CommodityPageHeader header={"Notification Center"}
											subtext={"Create and manage notifications to help keep your users informed, engaged, and confident about what's happening on the platform."}
											image={Notif_banner} pageName="NOTIFICATION"/>
										
										{  
											(isDataLoading || allNotificationData?.type !== "SUCCESS_ALL_NOTIFICATION_ACTION") ? 
											<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
												<LoadingSpinner size={{ height: '80px', width: '80px' }} />
											</div>
										:
										<>
                                            {
                                                showDeleteModal &&
                                                <NotificationPrompt 
                                                    header="Delete notification" 
                                                    description="This will permanently remove the notification and it will no longer be visible to users. This action can't be undone." 
                                                    buttonText="Delete" 
                                                    action={deleteNotification} setModal={setShowDeleteModal} data={currentData}/>
                                            }
                                            {
                                                showPublishModal &&
                                                <NotificationPrompt 
                                                    header="Publish notification" 
                                                    description="Once published, this notification will be sent to your selected audience. Publishing can't be undone." 
                                                    buttonText="Publish" 
                                                    action={publishNotification} setModal={setShowPublishModal} data={currentData}/>
                                            }
                                            <>
                                            {/* {
                                                showNewNotificationModal &&
                                                <>
                                                    <Modal
                                                    
                                                        closeOnOutsideClick={false}
                                                        onCloseModal={function oFe(){setshowNewNotificationModal(false)}}
                                                        primaryButtonProps={{
                                                            onClick: ()=>{
                                                                handleNewNotification("Published");
                                                                setshowNewNotificationModal(false);
                                                            },
                                                            size: 'medium',
                                                            text: "Publish",
                                                            variant: 'primary',
                                                            disabled: messageHeaderInput.trim()==="" || getHtmlTextLengthRegex(messageInput.trim())===0 || viewOnly
                                                        }}
                                                        tertiaryButtonProps={{
                                                            onClick: ()=>{
                                                                handleNewNotification("Draft")
                                                                setshowNewNotificationModal(false)
                                                            },
                                                            size: 'medium',
                                                            text: 'Save as draft',
                                                            variant: 'tertiary',
                                                            disabled: messageHeaderInput.trim()==="" || getHtmlTextLengthRegex(messageInput.trim())===0 || viewOnly
                                                        }}
                                                        showModal={true}
                                                        showLink={false}
                                                        showPrimaryButton={true}
                                                        showSecondaryButton={false}
                                                        showTertiaryButton={true}
                                                        showAuxiliaryButton={false}
                                                        type="S"
                                                        title={modalHeader}
                                                        >
                                                            <div>
                                                                <Row>
                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                        <TextInput
                                                                            label="Title"
                                                                            placeholderText="Type Here"
                                                                            showLabelIcon={false}
                                                                            isPassword={false}
                                                                            type="text"
                                                                            inputSize="medium"
                                                                            feedbackType="info"
                                                                            prefixType="none"
                                                                            suffixType="none"
                                                                            className="notificationMessageInput"
                                                                            onChange={(evt, value) =>{
                                                                                    setMessageHeaderInput(value);
                                                                                }
                                                                            }
                                                                            onUpdate={(value) =>{
                                                                                    setMessageHeaderInput(value);
                                                                                }
                                                                            }
                                                                            value={messageHeaderInput}
                                                                            required={true}
                                                                            disabled={viewOnly}
                                                                        />
                                                                    </Col>    
                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                        <div ref={messageRef}>
                                                                            <TextArea
                                                                                disableResize={true}
                                                                                // feedbackType={messageInputCount > 500 ? "error" : "info"}
                                                                                helperStyle={{}}
                                                                                // helperText={`(${messageInputCount}/500)`} 
                                                                                label="Message"
                                                                                onChange={(e) => {
                                                                                    setMessageInput(e.target.value);
                                                                                    setMessageInputCount(e.target.value.length);
                                                                                }}
                                                                                placeholder="Type Here"
                                                                                showCharacterCount={false}
                                                                                showLabelIcon={false}
                                                                                showToolbar={true}
                                                                                style={{
                                                                                    overflow: 'hidden',
                                                                                    minHeight: '40px'
                                                                                }}
                                                                                className="notificationMessageInput"
                                                                                // maxLength={500}
                                                                                value={messageInput}
                                                                                required={true}
                                                                                disabled={viewOnly}
                                                                                
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>        
                                                            </div>
                                                    </Modal>

                                                </>
                                            } */}
                                            </>
                                            {
                                                showNewNotificationModal &&
                                                <>
                                                    
                                                    <Sidepanel
                                                        className=""
                                                        onCloseSidePanel={function oFe(){
                                                            if (ignoreNextSidePanelClose) {
                                                                setIgnoreNextSidePanelClose(false);
                                                                return;
                                                            }
                                                            resetSidePanel();
                                                            setshowNewNotificationModal(false)
                                                        }}
                                                        primaryButtonProps={{
                                                            onClick: ()=>{
                                                                handleNewNotification("Published");
                                                                setshowNewNotificationModal(false);
                                                            },
                                                            size: 'medium',
                                                            text: "Publish",
                                                            variant: 'primary',
                                                            disabled: validateSidePanel() || viewOnly
                                                        }}
                                                        showFooter
                                                        showLink={false}
                                                        showSecondaryButton={true}
                                                        showTertiaryButton={false}
                                                        showAuxiliaryButton={false}
                                                        style={{}}
                                                        tertiaryButtonProps={{
                                                            onClick: ()=>{
                                                                handleNewNotification("Draft")
                                                                setshowNewNotificationModal(false)
                                                            },
                                                            size: 'medium',
                                                            text: 'Save as draft',
                                                            variant: 'tertiary',
                                                            disabled: validateSidePanel() || viewOnly
                                                        }}
                                                        secondaryButtonProps={{
                                                            onClick: ()=>{
                                                                handleNewNotification("Draft")
                                                                setshowNewNotificationModal(false)
                                                            },
                                                            size: 'medium',
                                                            text: 'Save as draft',
                                                            variant: 'tertiary',
                                                            disabled: validateSidePanel() || viewOnly
                                                        }}
                                                        title={modalHeader}
                                                        type="vertical"
                                                        showSidePanel={true}
                                                        horizontalSidepanelWidth = {"600px"}
                                                    >
                                                        
                                                        <div>
                                                            <Row>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    {
                                                                        viewOnly && currentData?.status==="Pending" &&
                                                                        <Notification
                                                                            className=""
                                                                            primaryActionLabel="Button"
                                                                            primaryActionOnClick={function wRe(){}}
                                                                            secondaryActionLabel="Button"
                                                                            secondaryActionOnClick={function wRe(){}}
                                                                            showIcon
                                                                            showText
                                                                            showTitle
                                                                            style={{ marginBottom:"16px" }}
                                                                            text="Pending release, you'll be emailed with the updates."
                                                                            title="Notification in Progress"
                                                                            type="warning"
                                                                            showActionButtons={false}
                                                                        />
                                                                    }
                                                                </Col>    
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <div className="ph-notification-required">
                                                                        *All Required
                                                                    </div>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{marginTop:"16px"}}>
                                                                    <div className="ph-notification-sub-header">
                                                                        Message Content
                                                                    </div>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                                                                    <TextInput
                                                                        label="Subject"
                                                                        placeholderText="Brief summary of the notification"
                                                                        showLabelIcon={false}
                                                                        isPassword={false}
                                                                        type="text"
                                                                        inputSize="medium"
                                                                        feedbackType="info"
                                                                        prefixType="none"
                                                                        suffixType="none"
                                                                        className="notificationMessageInput"
                                                                        onChange={(evt, value) =>{
                                                                                setMessageHeaderInput(value);
                                                                            }
                                                                        }
                                                                        onUpdate={(value) =>{
                                                                                setMessageHeaderInput(value);
                                                                            }
                                                                        }
                                                                        value={messageHeaderInput}
                                                                        required={true}
                                                                        disabled={viewOnly}
                                                                        
                                                                    />
                                                                </Col>    
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{marginTop:"24px"}}>
                                                                    <div ref={messageRef}>
                                                                        <TextArea
                                                                            disableResize={true}
                                                                            helperStyle={{}}
                                                                            label="Message"
                                                                            onChange={(e) => {
                                                                                setMessageInput(e.target.value);
                                                                                setMessageInputCount(e.target.value.length);
                                                                            }}
                                                                            placeholder="Provide the full details of your notification"
                                                                            showCharacterCount={false}
                                                                            showLabelIcon={false}
                                                                            showToolbar={true}
                                                                            style={{
                                                                                overflow: 'hidden',
                                                                                minHeight: '40px'
                                                                            }}
                                                                            className="notificationMessageInput"
                                                                            // maxLength={500}
                                                                            value={messageInput}
                                                                            required={true}
                                                                            disabled={viewOnly}
                                                                            
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <hr style={{width:"100%", borderTop: "1px solid #DADADA", boxSizing: "border-box", marginTop: "32px", marginBottom: "16px"}}></hr>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{marginTop:"16px"}}>
                                                                    <div className="ph-notification-sub-header">
                                                                        Recipients
                                                                    </div>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Radio
                                                                        feedbackType="info"
                                                                        items={[
                                                                            'All Procurement Hub users',
                                                                        ]}
                                                                        label="Choose who should receive this message (Only subscribed users will receive the email)"
                                                                        orientation="vertical"
                                                                        reference="radio button"
                                                                        showText
                                                                        size="small"
                                                                        style={{}}
                                                                        selectedItemIndex={selectedAllRadioIndex}
                                                                        onUpdate={function Fe(index,value) {
                                                                            setSelectedAllRadioIndex(index)
                                                                            setSelectedCategoryRadioIndex(null)
                                                                            setSelectedEmailRadioIndex(null)
                                                                            setSelectedBulkRadioIndex(null)
                                                                        }}
                                                                        disabled={viewOnly}
                                                                    />
                                                                    <Radio
                                                                        items={[
                                                                            'Users by category segment',
                                                                        ]}
                                                                        orientation="vertical"
                                                                        reference="radio button"
                                                                        showText
                                                                        size="small"
                                                                        style={{marginTop: "16px"}}
                                                                        selectedItemIndex={selectedCategoryRadioIndex}
                                                                        onUpdate={function Fe(index,value) {
                                                                            setSelectedCategoryRadioIndex(index)
                                                                            setSelectedAllRadioIndex(null)
                                                                            setSelectedEmailRadioIndex(null)
                                                                            setSelectedBulkRadioIndex(null)
                                                                        }}
                                                                        disabled={viewOnly}
                                                                    />
                                                                    {
                                                                        selectedCategoryRadioIndex === 0 &&
                                                                        <>
                                                                            <div className="ph-notification-section">
                                                                                <div className="ph-notification-sub-header" style={{textTransform:"none"}}>
                                                                                    Categories
                                                                                </div>
                                                                                <div style={{width:"100%"}}>
                                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                                        <SingleSelectDropdown
                                                                                            className='buy-con-dropdown-modal'
                                                                                            label={"L0 Categories*"}
                                                                                            childList={allCategoriesL0}
                                                                                            selectedValue={categoriesL0Selected}
                                                                                            setSelectedValue={onL0Selected}
                                                                                            disabled={viewOnly}
                                                                                            placeholder="Select L0 Category"
                                                                                        /> 
                                                                                    </Col>
                                                                                    {
                                                                                    categoriesL0Selected && categoriesL0Selected.length>0 &&
                                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{marginTop: "16px"}}>
                                                                                        <MultiSelectDropdown
                                                                                            className = {viewOnly ? 'buy-con-dropdown-modal ph-disabled-multiselect' : 'buy-con-dropdown-modal'}
                                                                                            label={"L1 Categories*"}
                                                                                            childList={allCategoriesL1}
                                                                                            selectedValue={categoriesL1Selected}
                                                                                            setSelectedValue={onL1Selected}
                                                                                            disabled={viewOnly}
                                                                                            placeholder={"Select L1 Categories"}
                                                                                        /> 
                                                                                    </Col>
                                                                                    }
                                                                                </div>   
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    <Radio
                                                                        feedbackType="info"
                                                                        helperText=""
                                                                        items={[
                                                                            'Specific individual users'
                                                                        ]}
                                                                        orientation="vertical"
                                                                        reference="radio button"
                                                                        showText
                                                                        size="small"
                                                                        style={{marginTop: "16px"}}
                                                                        selectedItemIndex={selectedEmailRadioIndex}
                                                                        onUpdate={function Fe(index,value) {
                                                                            setSelectedEmailRadioIndex(index)
                                                                            setSelectedAllRadioIndex(null)
                                                                            setSelectedCategoryRadioIndex(null)
                                                                            setSelectedBulkRadioIndex(null)
                                                                        }}
                                                                        disabled={viewOnly}
                                                                    />
                                                                    {
                                                                        selectedEmailRadioIndex === 0 &&
                                                                        <>
                                                                            <div className="ph-notification-section">
                                                                                <div className="ph-notification-sub-header" style={{textTransform:"none"}}>
                                                                                    PepsiCo email domains only
                                                                                </div>
                                                                                <div style={{width:"100%"}}>
                                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                                        <SingleSelectDropdown
                                                                                            className='buy-con-dropdown-modal'
                                                                                            label={"PH Users"}
                                                                                            childList={allEmailList}
                                                                                            selectedValue={[]}
                                                                                            setSelectedValue={onEmailSelected}
                                                                                            disabled={viewOnly}
                                                                                        /> 
                                                                                    </Col>
                                                                                </div>   
                                                                            </div>
                                                                            {
                                                                                finalUserEmailList && finalUserEmailList.length>0 &&
                                                                                <div className="ph-notification-section">
                                                                                    <div className="ph-notification-sub-header" style={{textTransform:"none"}}>
                                                                                        Send To
                                                                                    </div>
                                                                                    <div style={{width:"100%"}}>
                                                                                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignSelf:"baseline" }}>
                                                                                            {finalUserEmailList.map((text, idx) => (
                                                                                                <Tag
                                                                                                    key={`${text}-${idx}`}
                                                                                                    className=""
                                                                                                    color="default"
                                                                                                    isRemovable
                                                                                                    size="large"
                                                                                                    style={{}}
                                                                                                    text={text}
                                                                                                    type="default"
                                                                                                    onRemove={() => removeEmailFromList(text)}
                                                                                                    disabled={viewOnly}
                                                                                                />
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>   
                                                                                </div>
                                                                            }
                                                                            
                                                                        </>
                                                                    }
                                                                    
                                                                    <Radio
                                                                        feedbackType="info"
                                                                        helperText=""
                                                                        items={[
                                                                            'Bulk Upload Users'
                                                                        ]}
                                                                        orientation="vertical"
                                                                        reference="radio button"
                                                                        showText
                                                                        size="small"
                                                                        style={{marginTop: "16px"}}
                                                                        selectedItemIndex={selectedBulkRadioIndex}
                                                                        onUpdate={function Fe(index,value) {
                                                                            setSelectedBulkRadioIndex(index)
                                                                            setSelectedEmailRadioIndex(null)
                                                                            setSelectedAllRadioIndex(null)
                                                                            setSelectedCategoryRadioIndex(null)
                                                                        }}
                                                                        disabled={viewOnly}
                                                                    />
                                                                    {
                                                                        selectedBulkRadioIndex === 0 &&
                                                                        <>
                                                                            <div className="ph-notification-section">
                                                                                <div className="ph-notification-sub-header" style={{textTransform:"none"}}>
                                                                                    Bulk Upload Users via Excel
                                                                                </div>
                                                                                <div className="upload-note">
                                                                                    Use the template below to make sure it uploads correctly.
                                                                                </div>
                                                                                <div className="upload-template" 
                                                                                    // onClick={function clickButton() {
                                                                                    //     window.open(allNotificationData?.data?.templateURL, "_blank", "noopener")
                                                                                    // }}
                                                                                    tabIndex={0}
                                                                                    onClick={() => window.open(allNotificationData?.data?.templateURL, "_blank", "noopener")}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                                                            e.preventDefault();
                                                                                            window.open(allNotificationData?.data?.templateURL, "_blank", "noopener");
                                                                                        }
                                                                                    }}
                                                                                    >
                                                                                    <ButtonIcon
                                                                                        className=""
                                                                                        color="Interaction/Active"
                                                                                        icon="download"
                                                                                        label=""
                                                                                        onClick={function wRe(){}}
                                                                                        size="medium"
                                                                                        style={{}}
                                                                                        type="naked"
                                                                                    />
                                                                                    <div style={{ marginTop:"-2px", cursor: "pointer" }}>Download template</div>
                                                                                </div>
                                                                                <div style={{width:"100%"}}>
                                                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                                        {
                                                                                            (!viewOnly && (modalHeader === "New Notification" || (modalHeader === "Notification Draft" && bulkUploadFile == null))) &&
                                                                                            <ExcelFileUploader
                                                                                                excelFiles={excelFiles}
                                                                                                excelFilesForDisplay={excelFilesForDisplay}
                                                                                                setExcelFiles={setExcelFiles}
                                                                                                setExcelFilesForDisplay={setExcelFilesForDisplay}
                                                                                                setExcelFileSize={setExcelFileSize}
                                                                                                setExcelFileBase64={setExcelFileBase64}
                                                                                                setIsExcelFileProcessing={setIsExcelFileProcessing}
                                                                                                setUploadHelperText={setUploadHelperText}
                                                                                                updateExcelUploadDisplay={updateExcelUploadDisplay}
                                                                                                convertToBase64={convertToBase64}
                                                                                                uploadHelperText={uploadHelperText}
                                                                                                onBlockedDrop={() => setIgnoreNextSidePanelClose(true)}
                                                                                             />
                                                                                        }
                                                                                        {
                                                                                            
                                                                                            viewOnly
                                                                                            &&
                                                                                            <div style={{ marginTop:"8px" }}>
                                                                                                <PHFileUploadItem 
                                                                                                    file={bulkUploadFile} />
                                                                                            </div>

                                                                                        }
                                                                                        
                                                                                        {
                                                                                            
                                                                                            !viewOnly && (modalHeader === "Notification Draft")
                                                                                            &&
                                                                                            <div style={{ marginTop:"8px" }}>
                                                                                                {
                                                                                                    bulkUploadFile &&
                                                                                                    <PHFileUploadItem 
                                                                                                        showDelete={true}
                                                                                                        setBulkUploadFile={setBulkUploadFile} 
                                                                                                        setExcelFiles={setExcelFiles}
                                                                                                        setExcelFilesForDisplay={setExcelFilesForDisplay}
                                                                                                        setExcelFileSize={setExcelFileSize} 
                                                                                                        file={bulkUploadFile} />
                                                                                                }
                                                                                                {/* {
                                                                                                    bulkUploadFile==null && 
                                                                                                    
                                                                                                   <ExcelFileUploader
                                                                                                        excelFiles={excelFiles}
                                                                                                        excelFilesForDisplay={excelFilesForDisplay}
                                                                                                        setExcelFiles={setExcelFiles}
                                                                                                        setExcelFilesForDisplay={setExcelFilesForDisplay}
                                                                                                        setExcelFileSize={setExcelFileSize}
                                                                                                        setExcelFileBase64={setExcelFileBase64}
                                                                                                        setIsExcelFileProcessing={setIsExcelFileProcessing}
                                                                                                        setUploadHelperText={setUploadHelperText}
                                                                                                        updateExcelUploadDisplay={updateExcelUploadDisplay}
                                                                                                        convertToBase64={convertToBase64}
                                                                                                        uploadHelperText={uploadHelperText}
                                                                                                        />
                                                                                                }  */}
                                                                                            </div>

                                                                                        }
                                                                                    </Col>
                                                                                </div>   
                                                                            </div>
                                                                            
                                                                        </>
                                                                    }

                                                                </Col>    
                                                            </Row>        
                                                        </div>
                                                    </Sidepanel>
                                                </>
                                            }
                                            <Row gutter={[20, 20]}>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <>
                                                        <CardV2
                                                            className="ph-course-card"
                                                            cardBody={{
                                                                isDark: false,
                                                                slot: <div
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "100%",
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                justifyContent: "space-between",
                                                                                fontFamily: 'Inter',
                                                                                padding: "24px"
                                                                            }}
                                                                        >

                                                                                    <div className="card-title-container" style={{display:"flex", alignItems: "center", paddingBottom: "12px"}}>
                                                                                        <div className="card-title" style={{color: "#2d2d2d"}}>Notifications</div>
                                                                                        <Button
                                                                                            className=""
                                                                                            size="large"
                                                                                            style={{}}
                                                                                            iconLeading={"add_circle_outline"}
                                                                                            text="New Notification"
                                                                                            variant="primary"
                                                                                            onClick={()=> {
                                                                                                    setMessageHeaderInput("");
                                                                                                    setMessageInput("");
                                                                                                    setModalHeader("New Notification")
                                                                                                    setViewOnly(false);
                                                                                                    setshowNewNotificationModal(true)
                                                                                                }
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                                                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                                            {
                                                                                                allNotifications && allNotifications.length>0?
                                                                                                    <div className={"notification-table"} data-testid="test-notification-table">
                                                                                                        <DataTable
                                                                                                            columns={tableColumns}
                                                                                                            data={allNotifications}
                                                                                                            enableSorting={true}
                                                                                                            filters={undefined}
                                                                                                            isExpandable={false}
                                                                                                            isResizable={false}
                                                                                                            showColumnFilters={false}
                                                                                                            showFilterButton={false}
                                                                                                            showFilterToolbar={false}
                                                                                                            showPagination={true}
                                                                                                            showTableHeader={false}
                                                                                                            toolbarActions={undefined}
                                                                                                            pageIndex={0}
                                                                                                            pageSize={10}
                                                                                                        />
                                                                                                    </div>
                                                                                                    
    
                                                                                                :
                                                                                                <EmptyStateV2
                                                                                                    buttonHierarchyProps={{
                                                                                                        items: [
                                                                                                        ],
                                                                                                        primary: false,
                                                                                                        secondary: false,
                                                                                                        tertairy: false
                                                                                                    }}
                                                                                                    className=""
                                                                                                    description="Create and manage notifications here to communicate important updates to your users."
                                                                                                    icon="notification_important"
                                                                                                    style={{}}
                                                                                                    titleContent="No Notifications"
                                                                                                />
                                                                                            }
                                                                                            
                                                                                        </Col>
                                                                                    </Row>
                                                                        </div>,
                                                                
                                                                type: 'slot',
                                                                
                                                            }}
                                                            maxScrollHeight="90px"
                                                            state="interactive"
                                                            style={{}}
                                                            type="basic"
                                                            viewport="desktop"
                                                        />
                                                        
                                                    </>
                                                </Col>    
                                            </Row>
										</>
										}
									</div>
						</>
		)
	}
}

export default NotificationCenter;